import { render, staticRenderFns } from "./Editcliente.vue?vue&type=template&id=18ebac98&"
import script from "./Editcliente.vue?vue&type=script&lang=js&"
export * from "./Editcliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports